import { gql } from '@apollo/client';

const ASSESSMENT_REPORT_BASE = gql`
  fragment AssessmentReportBase on AssessmentReport {
    assessmentId
    totalStats {
      studentIds
      score
    }
    reportDomains {
      assessmentId
      domainId
      domain {
        id
        title
      }
      remediations {
        id
        text
      }
      stats {
        assessmentId
        domainId
        score
        studentIds
      }
    }
    reportSections {
      assessmentId
      assessmentSectionId
      assessmentSection {
        id
        title
      }
      stats {
        assessmentSectionId
        score
        studentIds
      }
    }
  }
`;

export { ASSESSMENT_REPORT_BASE };
